<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <!-- <button class="add-ticket" data-toggle="modal" data-target="#addTemplate">Add APK</button>
            <div class="personal-details">
                <h4 class="personal-details-title">Customer APK List</h4>
                <table class="table table-striped">
                    <thead>
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">APK Description</th>
                        <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let keyvalue of allCustomer | paginate : {
                            itemsPerPage: tableSize,
                            currentPage: page,
                            totalItems: count
                          } ;let i = index">
                        <th scope="col">{{i+1}}</th>
                        <th scope="col">{{keyvalue.description}}</th>
                        <th scope="col">
                            <svg xmlns="http://www.w3.org/2000/svg" (click)="getCustomerAPKById(keyvalue.customerAPKVersionId)" width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                            </svg> 
                        </th>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination-block" *ngIf="allCustomer.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div> -->

            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <p>Customer APK List</p>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off" >
                                <input type="text" placeholder="search privilege">
                            </form>
                            <i class="bi bi-search" ></i>
                        </div>
                        <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#addTemplate"><i class="bi bi-plus-lg"></i> Add</button>
                    </div>
                </div>
              
                <table class="table table-striped">
                    <thead>
                        <tr>
                          <th style="width: 80%;">APK Description</th>
                          <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let customer of allCustomer | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                        }  ;let i = index">
        
                        <p style="width: 80%;">{{customer.description}}</p>
                        <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                            <i *ngIf="actionControls.isModify" (click)="getCustomerAPKById(customer.customerAPKVersionId)" data-toggle="modal" data-target="#editModalView" class="bi bi-pencil-square"></i>
                            <i *ngIf="actionControls.isView" (click)="getCustomerAPKById(customer.customerAPKVersionId)" data-toggle="modal" data-target="#template-view" class="bi bi-eye-fill"></i>
                            <i *ngIf="actionControls.isDelete" (click)="del(customer.customerAPKVersionId)" data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i>
                        </p>
                    </div>
                </div>
        
        
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
        
                <div class="loader"  *ngIf="!isLoading && allCustomer.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>
        
                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                        [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>
        
          
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="addTemplate" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add Customer APK
                <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </span>
            </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="objectForm">
                    <div class="col-md-12 col-lg-12 des">
                        <label>Description</label>
                        <textarea formControlName="description" class="form-control" name="" id="" cols="30" rows="10"></textarea>
                    </div>

                    <div formArrayName="keyValueList">
                        <div *ngFor="let object of objectForm.controls.keyValueList['controls'];let i = index;let last = last" [formGroupName]="i">
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <input formControlName="key" placeholder="enter key" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-5 col-lg-5">
                                    <div class="form-group">
                                        <input formControlName="value" placeholder="enter value" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn" *ngIf="last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="addkeyValue()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removekeyValue(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" *ngIf="!last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removekeyValue(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="addCustomerAPK()" class="btn btn-primary">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <button data-toggle="modal" data-target="#view" id="template-view" style="display:none"></button> -->

<div class="modal fade" id="template-view" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Customer APK Version
                <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </span>
            </h5>
            </div>
            <div class="modal-body">
                <div class="form-group" *ngFor="let template of singleAPK">
                    <div class="row">
                        <div class="col-md-12 col-lg-12"  style="margin-bottom: 30px">
                            <label>Description</label>
                            <textarea class="form-control" style="height: 50px;" value="{{template.description}}" name="" id="" cols="30" rows="10"></textarea>
                        </div>
                        
                        <div class="keys">
                            <!-- <div class="col-md-6 col-lg-6" style="display: flex;justify-content:center">
                                <label>keys</label>
                            </div>
                            <div class="col-md-6 col-lg-6" style="display: flex;justify-content:center">
                                <label>keys</label>
                            </div> -->
                            <div *ngFor="let nameValue of template.keyValueList">
                                <div class="col-md-6 col-lg-6">
                                    <input type="text" value="{{nameValue.key}}" class="form-control">
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <input type="text" value="{{nameValue.value}}" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2"   class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
                <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </span>
            </h5>
        </div>
        <div class="modal-body">
            <p>are you sure? want to delete??</p>   
        <div class="modal-footer">
            <button type="button" id="closeModalButton1"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" (click)="deleteCustomerAPK()" class="btn btn-primary">Delete</button>
        </div>
        </div>
    </div>
    </div>
</div>


<div class="modal fade" id="editModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Update Customer APK
                <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </span>
            </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="objectForm">
                    <div class="col-md-12 col-lg-12 des">
                        <label>Description</label>
                        <textarea formControlName="description" class="form-control" name="" id="" cols="30" rows="10"></textarea>
                    </div>

                    <div formArrayName="keyValueList">
                        <div *ngFor="let object of objectForm.controls.keyValueList['controls'];let i = index;let last = last" [formGroupName]="i">
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <input formControlName="key" placeholder="enter key" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-5 col-lg-5">
                                    <div class="form-group">
                                        <input formControlName="value" placeholder="enter value" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn" *ngIf="last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="addkeyValue()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removekeyValue(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" *ngIf="!last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removekeyValue(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton5" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="updateCustomerAPK()" class="btn btn-primary">save changes</button>
                </div>
            </div>
        </div>
    </div>
</div>